// This file is generated by next-core EcmascriptClientReferenceModule.
const { createClientModuleProxy } = require("react-server-dom-turbopack/server");

__turbopack_context__.n(createClientModuleProxy("[project]/nextapp/node_modules/next/dist/esm/client/components/client-page.js"));
